export default "__VITE_ASSET__CuMzSdB3__"